import React from 'react';

import { Button } from 'components/Button';
import { UniformThumb, UniformMetaLine } from './UniformRow';

/**
 * A garment the employee has been handed but not yet answered for.
 *
 * Both answers are full-width and side by side. "Report a problem" is not
 * hidden behind an overflow menu: an employee holding the wrong size is exactly
 * the person this screen exists for, and burying their answer is how a wrong
 * size becomes a confirmed one.
 */
const PendingActionCard = ({ item, busy, onConfirm, onReport }) => (
  <div className="myu-pending-item">
    <div className="myu-row">
      <UniformThumb item={item} />
      <div className="myu-body">
        <p className="myu-name">{item.uniform_item_name}</p>
        <UniformMetaLine item={item} />
      </div>
    </div>

    <div className="myu-answers">
      <Button
        type="button"
        className="btn btn-primary btn-sm"
        disabled={busy}
        onClick={() => onConfirm(item)}
        label={busy ? 'Confirming…' : 'Confirm receipt'}
      />
      <Button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        disabled={busy}
        onClick={() => onReport(item)}
        label="Report a problem"
      />
    </div>
  </div>
);

export default PendingActionCard;
